module.exports = __webpack_public_path__ + "img/77408.15b2110e.svg";